import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Observable, BehaviorSubject } from 'rxjs';
import { TableElement } from './table.element';

export class TableElementWrapper implements TableElement {
	public selected: boolean;
	public styles: string;
	
	_id: string;
	_uuid: string;

	public constructor(private element: any) {
		this._uuid = this._genUUID();
	}

	_genUUID(): string {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
			// tslint:disable-next-line: no-bitwise
			const r = Math.random() * 16 | 0;
			// tslint:disable-next-line: no-bitwise
			const v = c === 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	}

	public get(column: string): string {
		return this.element[column];
	}

	public id(identifier?: any): string {
		if (identifier) {
			this._id = identifier;
		}
		if (this._id) {
			return this._id;
		} else {
			const elementId = this.get('id');

			if (elementId) {
				return elementId;
			} else {
				return this._uuid;
			}
		}
	}

	public isSelected(): boolean {
		return this.selected;
	}

	public setSelected(selected: boolean): void {
		this.selected = selected;
	}

	public getData(): any {
		return this.element;
	}
}

export class TableDataSource implements DataSource<any> {

	private listSubject = new BehaviorSubject<any[]>([]);

	private loadingSubject = new BehaviorSubject<boolean>(false);

	public loading$ = this.loadingSubject.asObservable();

	private list: TableElement[];
	private selectedItems: string[];

	constructor() {
	}

	loadData(list: TableElement[]) {
		this.list = (list ? list : []);

		this.reloadData();
		this.applySelectState();
	}

	reloadData() {
		this.loadingSubject.next(true);
		this.listSubject.next(this.list);
		this.loadingSubject.next(false);
	}

	addData(element: TableElement) {
		this.list.push(element);

		this.reloadData();
	}

	removeData(element: TableElement) {
		let index = 0;
		for (index = 0; index < this.list.length; index++) {
			if (element.id()) {
				if (this.list[index].id() === element.id()) {
					this.list.splice(index, 1);
					break;
				}
			} else if (this.list[index].getData() === element.getData()) {
				this.list.splice(index, 1);
				break;
			}
		}

		this.reloadData();
	}

	setSelectState(selectedItems: string[]) {
		this.selectedItems = selectedItems;

		if (this.list) {
			this.applySelectState();
		}
	}

	applySelectState() {
		this.list.forEach(tableElement => {
			if (this.selectedItems) {
				let index = 0;
				for (index = 0; index < this.selectedItems.length; index ++) {
					if (tableElement.id() === this.selectedItems[index]) {
						tableElement.setSelected(true);
						break;
					}
				}
			}
		});
	}

	resetSelectState() {
		this.selectedItems = [];
		this.list.forEach(tableElement => {
			tableElement.setSelected(false);
		});
	}
	
	allSelectState() {
		this.selectedItems = [];
		this.list.forEach(tableElement => {
			tableElement.setSelected(true);
			this.selectedItems.push(tableElement.id());
		});
	}

	isAllSelected() {
		if (this.list && this.list.length > 0) {
			for (const element of this.list) {
				if (!element.selected) {
					return false;
				}
			}
			return true;	
		} else {
			return false;
		}
	}

	getSelected(): any[] {
		return this.list.filter(tableElement => tableElement.selected).map((tableElement: any) => tableElement.getData());
	}

	connect(_: CollectionViewer): Observable<any[] | ReadonlyArray<any>> {
		return this.listSubject.asObservable();
	}

	disconnect(_: CollectionViewer): void {
		this.listSubject.complete();
		this.loadingSubject.complete();
	}

	getData(): any[] {
		return this.list;
	}
}
